import BlokWrap from "@/components/atoms/BlokWrap";
import SkeletonPC from "@/components/atoms/ProductCard/SkeletonPC";
import StoryblokComponent from "@/lib/bloks/StoryblokComponent/StoryblokComponent";
import type { ProductCard } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import type { ProductListingStoryblok } from "@/types/storyblok-blok-types";
import type { SbBlokData } from "@storyblok/js";
import { storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import { Suspense } from "react";
import ProductSlides from "./components/ProductSlides";
import styles from "./product-listing.module.css";

export const ServerUI = () => (
  <div>
    <>
      <SkeletonPC />
      <SkeletonPC />
      <SkeletonPC />
      <SkeletonPC />
    </>
  </div>
);

const ProductListingUI = ({
  blok,
  productCards,
}: {
  blok: ProductListingStoryblok;
  productCards: { card: ProductCard; tag: string }[];
}) => {
  const button = blok.button;
  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      animated="fadeY"
      anchor={blok?.id}
      className={clsx(styles.container, "product-listing")}
    >
      {(blok.title || blok.text) && (
        <div data-layout="page" className={`${styles.head}`}>
          {blok.title && <h2>{blok.title}</h2>}

          {blok.text && (
            <div>
              <p>{blok.text}</p>
            </div>
          )}
        </div>
      )}

      <Suspense fallback={<ServerUI />}>
        <ProductSlides cards={productCards} />
      </Suspense>

      {button && button?.length !== 0 && (
        <div data-layout="page" className={styles.link}>
          <StoryblokComponent blok={button[0]} />
        </div>
      )}
    </BlokWrap>
  );
};

export default ProductListingUI;
